import * as yup from "yup";

const companyDataSchema = yup.object({
  enterpriseName: yup.string().max(200).required(),
  gln: yup.string().max(200).required()
}).required();

export default companyDataSchema;
